module.exports = require('./_hide');



//////////////////
// WEBPACK FOOTER
// ./~/material-ui/~/babel-runtime/~/core-js/library/modules/_redefine.js
// module id = 312
// module chunks = 0